import Element from "./base/element";

export default class RatingBar extends Element {
	constructor(props) {
		super(props);

		this.$stars = null;

		this.value = null;
		this.VALUE_CHANGE_EVENT = 'valueChange';

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('RatingBar: Root element is not defined!');
		}

		this.$stars = this.$root.querySelectorAll('.rating-star');


		super.init();
	}

	addEventListeners() {
		this.$stars.forEach(($star) => {
			if (!$star.dataset || !$star.dataset.value) {
				throw new Error('RatingBar: Every star element must have an data-value attribute.');
			}

			$star.addEventListener('mouseenter', () => {
				this.$root.dataset.value = $star.dataset.value;
			});

			$star.addEventListener('click', () => {
				this.$root.dataset.value = $star.dataset.value;
				this.value = this.$root.dataset.value;
				this.dispatchEvent(this.VALUE_CHANGE_EVENT, this.value);
			});
		});

		this.$root.addEventListener('mouseleave', () => {
			if (this.value == null) {
				this.$root.removeAttribute('data-value');
			} else {
				this.$root.dataset.value = this.value;
			}
		});
	}

	dropState() {
		this.value = null;
		this.$root.removeAttribute('data-value');
		this.dispatchEvent(this.VALUE_CHANGE_EVENT);
	}
}